import MeetingVideoApi from "../../../service/MeetingVideoService";

export default {
  name: "MeetingVideoViewer",
  data() {
    return {
      contentHref: undefined,
      loading: false
    };
  },
  beforeMount: function() {
    this.processId = this.$route.query.processId;
    this.timestamp = this.$route.query.timestamp;
  },
  mounted() {
    this.retrieveMeetingVideo();
  },
  methods: {
    retrieveMeetingVideo() {
      this.loading = true;
      MeetingVideoApi.download(
        this,
        this.processId,
        this.timestamp,
        response => {
          const blob = new Blob([response], { type: "video/mp4" });
          this.contentHref = URL.createObjectURL(blob);
          this.loading = false;
        },
        error => {
          console.log(error);
          this.loading = false;
        }
      );
    },
    downloadVideo() {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = this.contentHref;
      link.download = this.processId + "-" + this.timestamp;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/meetingvideoviewer/mixin/MeetingVideoViewer.js